import { transactionStatuses } from "utils/constants";

const { completed, pendingAgent, pendingHold, failed, pending } =
  transactionStatuses;

export const getStatusColor = (value) => {
  let bgColor;
  let textColor;
  let text;
  switch (value) {
    case completed:
      bgColor = "#EAFCF2";
      textColor = "#27AE60";
      text = "Completed";
      break;

    case pendingAgent:
      bgColor = "#E4EAFD";
      textColor = "#1966FC";
      text = "Pending-Agent";
      break;

    case pending:
      bgColor = "#E4EAFD";
      textColor = "#0C1575";
      text = "Pending";
      break;

    case pendingHold:
      bgColor = "#E4EAFD";
      textColor = "#0C1575";
      text = "Pending-Hold";
      break;

    case failed:
      bgColor = "#FFE6E6";
      textColor = "#DC2C2C";
      text = "Failed";
      break;

    default:
      bgColor = "#E4EAFD";
      textColor = "#1966FC";
      text = value?.toLowerCase();
      break;
  }

  return { bgColor, textColor, text };
};
